import {
	BlackPause,
	ConfirmSolid,
	IcoConformeDaValidare,
	IcoConformeValidato,
	// IcoIncompleta,
	RejectSolid,
} from '@icons';

export const useStopLight = (checklistColor: string, isGara?: boolean, isGaraTemp?: boolean) => {
	const { icon, message } = ((checklistColor: string) => {
		switch (checklistColor) {
			case 'green':
				return {
					icon: <ConfirmSolid width={20} height={20} />,
					message: 'Conforme',
				};
			case 'green_white':
				return {
					icon: <IcoConformeDaValidare width={20} height={20} />,
					message: 'Conforme - da validare',
				};
			case 'green_white_settled':
				return {
					icon: <IcoConformeValidato width={20} height={20} />,
					message: 'Conforme - validato',
				};
			// case 'yellow':
			// 	return {
			// 		icon: <IcoIncompleta width={20} height={20} />,
			// 		message: isGara || isGaraTemp ? 'Non ancora disponibile' : 'Incompleta',
			// 	};
			case 'red':
				return {
					icon: <RejectSolid width={20} height={20} />,
					message: 'Non conforme',
				};
			case 'yellow':
			case 'grey':
			case 'gray':
				return {
					icon: (
						<BlackPause
							style={{
								fill: 'var(--np-primary-color)',
							}}
							width={20}
							height={20}
						/>
					),
					message: isGara || isGaraTemp ? 'Non applicabile' : 'In lavorazione',
				};
			case 'white':
				return {
					icon: <span style={{ display: 'inline-block', width: 20, height: 20, borderRadius: '50%', backgroundColor: '#D3D3D3' }} />,
					message: 'Da lavorare',
				};
			default:
				return {
					icon: <></>,
					message: 'Non classificato',
				};
			// break;
		}
	})(checklistColor);
	return { icon, message };
};
